const toUTC = (s) => new Date(/Z$|[+-]\d{2}:\d{2}$/.test(s) ? s : `${s}Z`);

// "DD MM YYYY HH:MM" (WIB) -> ISO string with +07:00, or null if invalid
export const parseWIB = (s) => {
  const m = s.match(/^(\d{2}) (\d{2}) (\d{4}) (\d{2}):(\d{2})$/);
  if (!m) return null;
  const [, d, mo, y, h, mi] = m.map(Number);
  const check = new Date(Date.UTC(y, mo - 1, d, h, mi));
  if (check.getUTCDate() !== d || check.getUTCMonth() !== mo - 1 || h > 23 || mi > 59) return null;
  return `${m[3]}-${m[2]}-${m[1]}T${m[4]}:${m[5]}:00+07:00`;
};

const parts = (iso) => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jakarta", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false,
  }).formatToParts(toUTC(iso)).map((x) => [x.type, x.value]));
  return { ...p, hour: p.hour === "24" ? "00" : p.hour };
};

export const toWIBInput = (iso) => {
  const p = parts(iso);
  return `${p.day} ${p.month} ${p.year} ${p.hour}:${p.minute}`;
};

export const fmtWIB = (iso) => {
  const p = parts(iso);
  return `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute} WIB`;
};

export const timeLeft = (iso) => {
  const ms = toUTC(iso) - new Date();
  const abs = Math.abs(ms);
  const days = Math.floor(abs / 86400000);
  const hours = Math.floor((abs % 86400000) / 3600000);
  const label = days ? `${days} hari ${hours} jam` : `${hours} jam ${Math.floor((abs % 3600000) / 60000)} menit`;
  return ms < 0 ? `Lewat ${label}` : `Sisa ${label}`;
};
